import { offlineOrdersRepository } from '../offlineOrders.repository';
import { offlinePriceTablesRepository } from '../offlinePriceTables.repository';

export default class OfflinePriceTableUtils {
  static async getOrderOrDefaultPriceTableId(orderId?: string): Promise<string> {
    if (orderId && typeof orderId === 'string') {
      return this.getOrderPriceTableId(orderId);
    }
    return this.getDefaultPriceTableId();
  }

  private static async getDefaultPriceTableId(): Promise<string> {
    const defaultPriceTable = await offlinePriceTablesRepository.getDefaultOrFail();
    return defaultPriceTable.id;
  }

  private static async getOrderPriceTableId(orderId: string): Promise<string> {
    const order = await offlineOrdersRepository.getByIdOrThrow(orderId);
    return order.priceTable.id;
  }
}
